import React from "react";
import {MenuItem} from "./MenuTypes.d";
import {
    IconDefinition,
    findIconDefinition
} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


export default function MenuItemComponent ({icon, label}: MenuItem) {
    const iconDefinition: IconDefinition = findIconDefinition({ prefix: 'fas', iconName: icon })

    return (
      <div
          className={"menu-button"}
      >
          <FontAwesomeIcon icon={iconDefinition} /> {label}
      </div>
    );
}